import type { WebshopPackage } from '../../../schema/webshop-package'

export const FETCH_PACKAGES: 'packages/FETCH' = 'packages/FETCH'
export const SET: 'packages/SET' = 'packages/SET'

export type fetchSuggestiblePackagesType = {
  type: typeof FETCH_PACKAGES,
  payload: undefined,
}

export type setSuggestiblePackagesType = {
  payload: Array<WebshopPackage>,
  type: typeof SET,
}

export type Actions = fetchSuggestiblePackagesType | setSuggestiblePackagesType

export const fetchSuggestiblePackages = (): fetchSuggestiblePackagesType => ({
  type: FETCH_PACKAGES,
  payload: undefined,
})

export const setSuggestiblePackages = (
  packages: WebshopPackage[],
): setSuggestiblePackagesType => ({
  payload: packages,
  type: SET,
})
